import React, { createContext, useContext } from 'react';
import useTaxonomy from '../hooks/useTaxonomy';

const TaxonomyContext = createContext(null);

export const TaxonomyProvider = ({ children }) => {
	const taxonomy = useTaxonomy();
	return (
		<TaxonomyContext.Provider value={taxonomy}>
			{children}
		</TaxonomyContext.Provider>
	);
};

export const useTaxonomyContext = () => useContext(TaxonomyContext);
